import { Component, Input, OnInit } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { Router } from "@angular/router";
import { Platform, PopoverController } from "@ionic/angular";
import { BackService } from "../../services/back.service";
import { AuthService } from "../../services/auth.service";
import { UserRole } from "../../enums/global-enums";
import {
  isMobile,
  smallScreenHeight,
} from "../../global-functions/global-functions";
import { OdataSachbearbeiterRequest } from "../../../api/models/odata-sachbearbeiter-request";
import { SachbearbeiterService } from "../../../api/services/sachbearbeiter.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  showBackButton: boolean = true;

  @Input()
  overrideBackButtonUrl: string;

  userData: any;
  enableDarkmode = false;
  uniquePopoverID = "";
  smallScreenHeight: boolean;
  smallScreenWidth: boolean;
  mailmanagerAktiv: boolean;

  popupPopoverOpen = false;
  popupPopoverEvent: any;
  popoverCopyRegex = /\d+\/\d+/;

  readonly localStorageDarkModeSettingKey = "fairapp_darkskin";

  constructor(
    private oidcSecurityService: OidcSecurityService,
    private popoverController: PopoverController,
    private backService: BackService,
    private platform: Platform,
    private sachbearbeiterService: SachbearbeiterService,
    public router: Router,
    public authService: AuthService,
  ) {
    this.uniquePopoverID = Math.random().toString(36).substring(7);
  }

  ngOnInit() {
    this.oidcSecurityService.userData$.subscribe((userData) => {
      this.userData = userData;
      const token = this.oidcSecurityService.getToken();
      const sb = userData?.sb;
      if (!token || !sb) {
        this.mailmanagerAktiv = false;
      } else {
        this.sachbearbeiterService
          .sachbearbeiterOdataRetrieveCreate({
            token: token,
            sb_kuerzel: sb,
          } as OdataSachbearbeiterRequest)
          .subscribe((sachbearbeiter) => {
            this.mailmanagerAktiv = sachbearbeiter?.MailManagerAktiv;
          });
      }
    });

    const systemPrefersDark = window.matchMedia("(prefers-color-scheme: dark)");
    const darkEnabled =
      localStorage.getItem(this.localStorageDarkModeSettingKey) === null
        ? systemPrefersDark.matches
        : this.loadThemeSettingFromLocalStorage();
    this.saveThemeSettingToLocalStorage(darkEnabled);
    this.setDarkMode(darkEnabled);
    this.smallScreenHeight = smallScreenHeight(this.platform);
    this.smallScreenWidth = isMobile(this.platform);
  }

  toggleDarkTheme() {
    const darkEnabled = !this.loadThemeSettingFromLocalStorage();
    this.saveThemeSettingToLocalStorage(darkEnabled);
    this.setDarkMode(darkEnabled);
  }

  saveThemeSettingToLocalStorage(darkModeEnabled: boolean) {
    localStorage.setItem(
      this.localStorageDarkModeSettingKey,
      String(darkModeEnabled),
    );
  }

  loadThemeSettingFromLocalStorage() {
    return JSON.parse(
      localStorage.getItem(this.localStorageDarkModeSettingKey),
    );
  }

  setDarkMode(enabled: boolean) {
    this.enableDarkmode = enabled;
    document.body.classList.toggle("dark-layout", enabled);
    document.body.classList.toggle("default-layout", !enabled);
  }

  getUsername() {
    return `${this.userData?.sb}`;
  }

  goBack() {
    this.router.navigate(
      [this.overrideBackButtonUrl ?? this.backService.backPath],
      { replaceUrl: true },
    );
  }

  logout() {
    this.oidcSecurityService.logoff();
  }

  dismissPopover() {
    this.popoverController.dismiss();
  }

  copyToClipboard(event: Event, text: string) {
    const match = text.match(this.popoverCopyRegex);
    if (!match) {
      return;
    }
    event.stopPropagation();

    const textToCopy = match[0];
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.popupPopoverEvent = event;
      this.popupPopoverOpen = true;
      setTimeout(() => {
        this.popupPopoverOpen = false;
      }, 1500);
    });
  }

  highlightMatch(text: string) {
    return text.replace(
      this.popoverCopyRegex,
      (match) => `<span class="highlight-copy-text">${match}</span>`,
    );
  }

  protected readonly UserRole = UserRole;
}
